<script>
  export let bgColor = 'black'
  export let projectName = ''
  export let copyRightColor = 'white'
  export let homePageUrl = 'https://www.thenewslens.com/'
  export let tnlLogoUrl = 'https://bucket-image.inkmaginecms.com/version/desktop/1/image/2024/08/fe833af1-856d-48ac-8c5b-60e89bcee0ee.png'
</script>

<style>
  .copyright {
    font-size: 0.75rem;
    line-height: 1rem;
    padding-top: 0.5rem;
    color: var(--text-color);
  }
  footer {
    letter-spacing: 0.025em;
    font-weight: 300;
    color: white;
    text-align: center;
    padding: 2.5rem;
    background-color: var(--bg-color);
  }

  figure {
    margin: 0 auto;
  }
  img {
    margin: 0 auto;
  }

  @media (min-width: 640px) {
    .copyright {
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
  }
</style>

<footer style="--bg-color: {bgColor};">
  <a href={homePageUrl}>
    <figure>
      <img
        width="200px"
        src={`${tnlLogoUrl}?utm_source=TNL-interactive&utm_medium=footer&utm_campaign=${projectName}`}
        alt="tnl-white-logo"
      />
    </figure>
  </a>
  <div class="copyright" style="--text-color: {copyRightColor}">Copyright © 2026 The News Lens 關鍵評論網</div>
</footer>
